/**
 * 浮窗里那块「**这个字还出现在**」—— 两个浮窗（导入预览 / 浏览与编辑）**共用一份**。
 *
 * 用户原话：
 *
 * > "在**弹出的浮窗里面加一个功能，直接定位到另外一个字**，让我能跳转过去……
 * >  对于任何一个配对或者多音字，都有**跳转到另外一个字**的功能。"
 *
 * > "在「浏览」模块下面也一样……**同一个界面中出现多音字，也能互相跳转**。"
 *
 * 所以每一项都是**按钮**（不是一个只读的位置标签）：
 *
 *   · 可见文字：`第 7 行第 1 个字 · 未标音`（导入预览）/ `第 12 个 · 识字表`
 *     （浏览与编辑，标过音的再缀 `· 已标 cháng`）；
 *   · 点它 ⇒ `onJump(key)` ⇒ 调用方**先关浮窗**，再滚到那张卡 + 短暂高亮 2 秒
 *     （`useHanziJump`/`runHanziJump`，见 `hanziJump.ts`）—— **到此为止**：
 *     ⛔ 跳完**不打开**目标位置的浮窗，用户自己点那张卡才开（2026-10-20 用户要求）；
 *   · 手机可点性：每一项 `min-h-[44px]`（与字卡、读音按钮同一口径）。
 *
 * ⚠️ `emptyText` 不传且 `occurrences` 为空 ⇒ **整块不渲染**：字只出现一次时
 *    不能留一个"这个字还出现在："的空壳（用户明确要求）。
 */
import { cn } from '../../lib/utils';
import {
  describeHanziJumpCard,
  describeHanziJumpStatus,
  type HanziJumpCard,
} from './hanziJump';

export interface HanziJumpLinksProps {
  /** 其它位置（不含当前这个）。 */
  occurrences: readonly HanziJumpCard[];
  /** 点其中一项：调用方据此跳转。 */
  onJump: (key: string) => void;
  /**
   * 一项都没有时显示的那句话（导入预览传"没有别的位置了…"）。
   * **不传** ⇒ 空的时候整块不渲染（浏览与编辑用）。
   */
  emptyText?: string;
  /** 标题（两处默认同一句）。 */
  title?: string;
}

export function HanziJumpLinks({
  occurrences,
  onJump,
  emptyText,
  title = '这个字还出现在：',
}: HanziJumpLinksProps) {
  if (occurrences.length === 0 && emptyText === undefined) return null;

  return (
    <div
      className="rounded-xl border border-slate-200 bg-slate-50 px-3 py-2"
      data-hanzi-jump-list="true"
    >
      <p className="text-sm font-medium text-slate-800">{title}</p>
      {occurrences.length === 0 ? (
        <p className="mt-1 text-sm text-slate-600">{emptyText}</p>
      ) : (
        <>
          <ul className="mt-1 space-y-1">
            {occurrences.map((card) => {
              const status = describeHanziJumpStatus(card);
              const full = describeHanziJumpCard(card);
              return (
                <li key={card.key}>
                  <button
                    type="button"
                    onClick={() => onJump(card.key)}
                    data-jump-key={card.key}
                    aria-label={`跳到 ${full}`}
                    title={`跳到 ${full}`}
                    className={cn(
                      'flex w-full min-w-0 items-center gap-2 rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-left text-sm',
                      'min-h-[44px] hover:bg-brand-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-200',
                    )}
                  >
                    <span className="min-w-0 truncate text-slate-800">{card.label}</span>
                    {status !== '' && (
                      <span
                        className={cn(
                          'shrink-0 text-xs',
                          card.reading !== undefined && card.reading !== ''
                            ? 'text-emerald-700'
                            : 'text-rose-700',
                        )}
                      >
                        · {status}
                      </span>
                    )}
                    <span className="ml-auto shrink-0 text-xs font-medium text-brand-700">
                      跳过去 →
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
          <p className="mt-1 text-[11px] leading-relaxed text-slate-500">
            点一个位置就跳过去：滚到那张卡、亮 2 秒，并打开它的读音浮窗。
          </p>
        </>
      )}
    </div>
  );
}
